import { useEffect } from 'react';
import useCustomHook from './hooks';
import { useForm, FormProvider } from 'react-hook-form';
import { withStyles } from '@mui/styles';
import { InputV2, ButtonLoading, PageContainer, Icons , InputCurrency } from 'components';
import { useStyles } from './style';
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  TableHead,
  Paper,
  Grid,
  Button,
  Typography,
} from '@mui/material';
import createToast from 'components/Toast/Toast';
import { useParams, useNavigate } from 'react-router-dom';
import InvoiceServices from '../InvoiceDebtor/services/InvoiceServices';
import { constBreadCrumbsTitle } from 'utility';
export default function ReduceInvoice() {
  const { submitLoading, setSubmitLoading, data, setData, loading, setLoading } = useCustomHook();

  const methods = useForm();
  const classes = useStyles();
  const params = useParams();
  const navigate = useNavigate();

  const fetchInvoice = async () => {
    setLoading(true);
    try {
      const result = await InvoiceServices.getInvoice(params?.id);
      if (!result.result[0])
        return Promise.reject({
          response: { data: { message: 'فاکتور یافت نشد' } },
        });
      setData(result?.result[0]);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInvoice();
  }, []);

  const submitForm = async () => {
    const items = methods.getValues()?.items;
    const bodyData = {
      id: data?.id,
      invoiceItemId: data?.invoiceItemSrvs?.map?.((item) => item.id),
      price: items?.map((item) => Number(item.price)),
      itemDescription: items?.map((item) => (item.description ? item.description : '_')),
      quantity: items?.map((item) => Number(item.quantity)),
      preferredTaxRate: Number(methods.getValues()?.preferredTaxRate),
    };
    setSubmitLoading(true);
    try {
      await InvoiceServices.reduceInvoice(bodyData);
      createToast('موفق', 'عملیات با موفقیت انجام شد', 'success');
    } catch (error) {
    } finally {
      setSubmitLoading(false);
    }
  };

  const getTableData = data?.invoiceItemSrvs.map?.((item, i) => ({
    id: item.id,
    description: (
      <InputV2
        name={`items[${i}].description`}
        label="توضیحات"
        showLabel={false}
        errors={methods.formState.errors}
        register={methods.register}
        control={methods.control}
        multiline
        rows={2}
        rowsMax={4}
        defaultValue={item.description}
      />
    ),
    price: (
      <InputCurrency
        name={`items[${i}].price`}
        label="قیمت"
        showLabel={false}
        errors={methods.formState.errors}
        register={methods.register}
        rules={['required', 'isInt', `isMax|${item.amount}`]}
        control={methods.control}
        currency
        defaultValue={item.amount}
        value={methods.watch(`items[${i}].price`)}
        onChangeValue={(price) => {
          const discount = Number(methods.getValues().items?.[i].discount);
          if (Number(discount) > price) {
            methods.setError(`product[${i}].discount`, {
              message: `تخفیف نباید از ${price} بیشتر باشد`,
            });
          } else if (Number(discount) <= price) {
            methods.setError(`product[${i}].discount`, {
              message: null,
            });
          }
        }}
      />
    ),
    quantity: (
      <InputV2
        name={`items[${i}].quantity`}
        label="تعداد"
        showLabel={false}
        errors={methods.formState.errors}
        register={methods.register}
        rules={['required', 'isInt', `isMax|${item.quantity}`]}
        control={methods.control}
        currency
        currencyText="عدد"
        defaultValue={item.quantity}
      />
    ),
  }));

  const hint = ' با کاهش فاکتور مبلغی از فاکتور پرداخت شده به مشتری بازگردانده می‌شود.';

  return (
    <PageContainer
      loading={loading}
      title={`کاهش فاکتور ${params.id}`}
      breadcrumbs={constBreadCrumbsTitle.INVOICE_REDUCE}
      description={hint}
      meta={
        <Button
          endIcon={<Icons icon="CaretLeft" color="#2b3990" size="23" />}
          color="primary"
          variant="outlined"
          onClick={() => navigate(-1)}
        >
          بازگشت
        </Button>
      }
    >
      <FormProvider {...methods}>
        <form>
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell align="center">ردیف</StyledTableCell>
                  <StyledTableCell align="center">شناسه</StyledTableCell>
                  <StyledTableCell align="center" width="50%">
                    توضیحات
                  </StyledTableCell>
                  <StyledTableCell align="center">قیمت</StyledTableCell>
                  <StyledTableCell align="center">تعداد</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {getTableData?.map?.((item, i) => (
                  <StyledTableRow key={i}>
                    {[i + 1, item.id, item.description, item.price, item.quantity].map((x, ii) => (
                      <StyledTableCell key={ii}>{x}</StyledTableCell>
                    ))}
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Grid lg={2} md={3} sm={6} xs={12} item>
            <InputV2
              label="مالیات"
              name="preferredTaxRate"
              control={methods.control}
              register={methods.register}
              errors={methods.formState.errors}
              tooltip="درصد مالبات باید کوچکتر مساوی مقداری باشد که هنگام صدور فاکتور تعیین شده است"
              // defaultValue={useMemo(
              //   () => Math.floor((data?.vat / data?.totalAmount) * 100),
              //   [data]
              // )}
              defaultValue="9"
              currency
              currencyText="درصد"
              minimumValue="0"
              rules={[
                'required',
                // `isMax|${Math.floor((data?.vat / data?.totalAmount) * 100)}`
              ]}
            />
          </Grid>
          <Typography color="primary" />
          <Grid style={{ marginTop: '1em' }} direction="row" container item xs={12} justifyContent='flex-end'>
            <ButtonLoading
              name="ثبت"
              loading={submitLoading}
              variant="contained"
              color="primary"
              onClick={methods.handleSubmit(submitForm)}
            />
          </Grid>
        </form>
      </FormProvider>
    </PageContainer>
  );
}

const StyledTableCell = withStyles(() => ({
  head: {
    backgroundColor: 'rgb(238, 241, 245)',
    color: '#546e7a',
  },
  body: {
    fontSize: 14,
    paddingTop: 0,
    paddingBottom: '0',
  },
}))(TableCell);

const StyledTableRow = withStyles(() => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: '#f9f9f9',
    },
  },
}))(TableRow);
